import { getClientId } from 'utils/getClientId'
import { ShoppingCart } from 'models/Product'
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'

type PatchShoppingCartRequest = {
  items: {
    productId: string
    quantity: number
  }[]
  clientId?: string
  chargebeePaymentToken?: string
}

export namespace PatchShoppingCart {
  export type Response = ShoppingCart
  export type Variables = PatchShoppingCartRequest
  export type Error = Api.Error
  export type Options = UseMutationOptions<Response, Error, Variables>
}

export const usePatchShoppingCart = (options?: PatchShoppingCart.Options) => {
  const clientId = getClientId()
  const queryClient = useQueryClient()

  const mutationFn = async (data: PatchShoppingCart.Variables) => {
    return ApiClient.patch<PatchShoppingCart.Response>(`/v1/clients/${clientId}/shopping-cart`, {
      data,
    })
  }

  const mutation = useMutation<
    PatchShoppingCart.Response,
    PatchShoppingCart.Error,
    PatchShoppingCart.Variables
  >(mutationFn, {
    ...options,
    onSuccess: () => {
      queryClient.refetchQueries(['shoppingCart'])
    },
  })

  return { ...mutation, patchShoppingCart: mutation.mutate }
}
